import { RETAILERS } from '@/lib/affiliateShop';
import { Info, ExternalLink } from 'lucide-react';

// Small honest affiliate disclosure (required by ASA/consumer rules).
export function AffiliateDisclosure({ className = '' }) {
  return (
    <p className={`flex items-start gap-2 text-[11px] uppercase tracking-wide text-slate-500 ${className}`} data-testid="affiliate-disclosure">
      <Info size={13} className="shrink-0 mt-0.5" />
      <span>Affiliate links — we may earn a small commission if you buy through them, at no extra cost to you. It keeps TradesMate's calculators free.</span>
    </p>
  );
}

// A row of retailer buttons that search each shop for `q`. Skimlinks converts
// supported ones into commission links automatically at runtime.
export function RetailerLinks({ q, retailers = RETAILERS, size = 'sm' }) {
  const pad = size === 'sm' ? 'px-2.5 py-1.5 text-xs' : 'px-3 py-2 text-sm';
  return (
    <div className="flex flex-wrap gap-2" data-testid="retailer-links">
      {retailers.map((r) => (
        <a
          key={r.name}
          href={r.url(q)}
          target="_blank"
          rel="sponsored noopener noreferrer"
          data-testid={`retailer-${r.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          className={`inline-flex items-center gap-1.5 rounded-full font-semibold uppercase tracking-wide border border-slate-200 bg-white text-slate-800 hover:bg-brand hover:text-white hover:border-brand transition-colors ${pad}`}
        >
          {r.name}
          <ExternalLink size={12} className="opacity-60" />
        </a>
      ))}
    </div>
  );
}
